export const HANDLE_LOGIN_ROUTE = 'HANDLE_LOGIN_ROUTE';
export const SET_ROUTE_END = 'SET_ROUTE_END';
export const SET_ROUTE_INFO = 'SET_ROUTE_INFO';
export const VERIFY_AGE_VERIFICATION_DEEPLINK_ROUTE = 'VERIFY_AGE_VERIFICATION_DEEPLINK_ROUTE';
export const VERIFY_CAMPAIGN_DEEPLINK_ROUTE = 'VERIFY_CAMPAIGN_DEEPLINK_ROUTE';
export const VERIFY_CONFIRMATION_DEEPLINK_ROUTE = 'VERIFY_CONFIRMATION_DEEPLINK_ROUTE';
export const VERIFY_EMAIL_REMOVAL_DEEPLINK_ROUTE = 'VERIFY_EMAIL_REMOVAL_DEEPLINK_ROUTE';
export const VERIFY_EMAIL_SUBSCRIPTION_TOKEN_ROUTE = 'VERIFY_EMAIL_SUBSCRIPTION_TOKEN_ROUTE';
export const VERIFY_EXPLORE_ROUTE = 'VERIFY_EXPLORE_ROUTE';
export const VERIFY_GOLD_DEEPLINK_ROUTE = 'VERIFY_GOLD_DEEPLINK_ROUTE';
export const VERIFY_GOLD_ROUTE = 'VERIFY_GOLD_ROUTE';
export const VERIFY_INCENTIVES_DEEPLINK_ROUTE = 'VERIFY_INCENTIVES_DEEPLINK_ROUTE';
export const VERIFY_MESSAGES_ROUTE = 'VERIFY_MESSAGES_ROUTE';
export const VERIFY_MERCHANDISING_ROUTE = 'VERIFY_MERCHANDISING_ROUTE';
export const VERIFY_MUTUAL_FRIENDS_ROUTE = 'VERIFY_MUTUAL_FRIENDS_ROUTE';
export const VERIFY_NAVIGATE_ROUTE = 'VERIFY_NAVIGATE_ROUTE';
export const VERIFY_PLUS_ROUTE = 'VERIFY_PLUS_ROUTE';
export const VERIFY_PREFERENCES_ROUTE = 'VERIFY_PREFERENCES_ROUTE';
export const VERIFY_PROMO_ROUTE = 'VERIFY_PROMO_ROUTE';
export const VERIFY_REMOTE_VIEW_ROUTE = 'VERIFY_REMOTE_VIEW_ROUTE';
export const VERIFY_SETTINGS_ROUTE = 'VERIFY_SETTINGS_ROUTE';
export const VERIFY_WEB_PROFILE_ROUTE = 'VERIFY_WEB_PROFILE_ROUTE';

export const ROUTE_NAVIGATE = 'NAVIGATE';
